var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Paper",
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.655,
    height: 69.223,
    viewBox: "0 0 67.655 69.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-1",
    d: "M-2367.941-3920.285c-4.677,0-9.031-2.617-12.257-7.369a30.476,30.476,0,0,1-4.8-16.989,30.47,30.47,0,0,1,4.8-16.988c3.227-4.753,7.58-7.37,12.257-7.37s9.03,2.616,12.257,7.37a30.466,30.466,0,0,1,4.8,16.988,30.472,30.472,0,0,1-4.8,16.989C-2358.91-3922.9-2363.263-3920.285-2367.941-3920.285Zm0-45.48c-3.572,0-6.975,2.114-9.58,5.952a27.216,27.216,0,0,0-4.243,15.17,27.222,27.222,0,0,0,4.243,15.171c2.606,3.838,6.009,5.951,9.58,5.951s6.974-2.113,9.581-5.951a27.226,27.226,0,0,0,4.243-15.171,27.22,27.22,0,0,0-4.243-15.17C-2360.967-3963.651-2364.369-3965.765-2367.941-3965.765Z",
    transform: "translate(2385 3969)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-1",
    d: "M-2308.084-3847.338c-3.779,0-6.738-4.022-6.738-9.157s2.96-9.157,6.738-9.157,6.737,4.022,6.737,9.157S-2304.306-3847.338-2308.084-3847.338Zm0-15.079c-1.866,0-3.5,2.768-3.5,5.922s1.637,5.922,3.5,5.922,3.5-2.767,3.5-5.922S-2306.219-3862.417-2308.084-3862.417Z",
    transform: "translate(2325.144 3880.853)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-1",
    d: "M-2164.332-3899.778a18.406,18.406,0,0,1-18.386-18.385v-26.9a1.618,1.618,0,0,1,1.618-1.617,1.618,1.618,0,0,1,1.618,1.617v26.9a15.167,15.167,0,0,0,15.15,15.15,15.167,15.167,0,0,0,15.15-15.15v-32.784A14.834,14.834,0,0,0-2164-3965.765h-18.428a1.618,1.618,0,0,1-1.618-1.617,1.618,1.618,0,0,1,1.618-1.618H-2164a18.073,18.073,0,0,1,18.053,18.053v32.784A18.406,18.406,0,0,1-2164.332-3899.778Z",
    transform: "translate(2213.601 3969)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/Paper.cd684289.svg";
export { ForwardRef as ReactComponent };